<template>
    <div v-bind:class="{'loading' : isLoadingContent}">
        <basket-empty v-if="emptyBasket"></basket-empty>
        <basket-content v-if="notEmptyBasket"></basket-content>
    </div>
</template>

<script>
    export default {
        computed: {
            emptyBasket: function () {
                return this.$store.getters.isBasketEmpty;
            },
            notEmptyBasket: function () {
                return !this.emptyBasket;
            },
            isLoadingContent: function () {
                return this.$store.getters.isLoadingBasket;
            }
        }
    }
</script>